import {
  useCallback,
  memo
}                    from 'react';
import PropTypes     from 'prop-types';
import isEmpty       from 'lodash/isEmpty';
import ViewAction    from './Action';
import cns           from 'classnames';
import styles        from './site-view.module.scss';

const SiteView = ({
  title, subtitle, actions, className, children, centeredHeader 
}) => {
  const isHeaderVisible = useCallback(() => {
    return !isEmpty(title) || !isEmpty(subtitle) || !isEmpty(actions);
  });

  return (
    <div className={cns(styles.component, {
      [className]: !!className,
      [styles.centeredHeader]: centeredHeader,
      [styles.has_actions]: !isEmpty(actions)
    })}>
      <If condition={isHeaderVisible()}>
        <div className={styles.header}>
          <div className={styles.header_content}>
            <div className={styles.header_left}>
              <h1 className={styles.title}>{title}</h1>
              <If condition={subtitle}>
                <h2 className={styles.subtitle}>{subtitle}</h2>
              </If>
            </div>
            <div className={styles.header_right}>
              <If condition={!isEmpty(actions)}>
                <div className={styles.header_actions}>
                  <For each="action" of={actions} index="index">
                    <ViewAction key={index} {...action}/>
                  </For>
                </div>
              </If>
            </div>
          </div>            
        </div>
      </If>
      
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

SiteView.propTypes = {
  className:      PropTypes.string,
  title:          PropTypes.string,
  subtitle:       PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.element
                  ]),
  actions:        PropTypes.array,
  centeredHeader: PropTypes.bool
};

SiteView.defaultProps = {
  actions: [],
  centeredHeader: false
};

export default memo(SiteView);